var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "thumbs-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 11.666V1.66602",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.50002 15.0994L8.33335 11.666H3.47502C3.21627 11.666 2.96109 11.6058 2.72966 11.4901C2.49823 11.3743 2.29693 11.2063 2.14168 10.9993C1.98644 10.7924 1.88152 10.5521 1.83523 10.2975C1.78895 10.0429 1.80257 9.78107 1.87502 9.53268L3.81668 2.86602C3.91766 2.51982 4.12819 2.21572 4.41668 1.99935C4.70518 1.78298 5.05607 1.66602 5.41668 1.66602H16.6667C17.1087 1.66602 17.5326 1.84161 17.8452 2.15417C18.1578 2.46673 18.3334 2.89065 18.3334 3.33268V9.99935C18.3334 10.4414 18.1578 10.8653 17.8452 11.1779C17.5326 11.4904 17.1087 11.666 16.6667 11.666H14.3667C14.0566 11.6662 13.7527 11.7528 13.4892 11.9162C13.2257 12.0797 13.013 12.3133 12.875 12.591L10 18.3327C9.60704 18.3278 9.22024 18.2342 8.86851 18.0589C8.51679 17.8835 8.20924 17.6309 7.96885 17.32C7.72845 17.0091 7.56142 16.6479 7.48024 16.2633C7.39905 15.8788 7.40581 15.4809 7.50002 15.0994Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbs-down.8c307cc8dff2d941186bb166a94e8fee.svg";
export { ForwardRef as ReactComponent };